// extracted by mini-css-extract-plugin
export default {"card":"multiTopSources_card__e7oEA","header":"multiTopSources_header__113lf","title":"multiTopSources_title__yFoM1","subtitle":"multiTopSources_subtitle__ampcZ"};